var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuitsMeLogoWhiteout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 998.39 284.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}.cls-2{mask:url(#mask);}.cls-3{mask:url(#mask-2-2);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 187.57,
    height: 284.44,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "0 0 187.57 0 187.57 284.44 0 284.44 0 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-2",
    x: 0,
    y: 0,
    width: 998.39,
    height: 284.44,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    className: "cls-1",
    points: "0 284.44 998.4 284.44 998.4 0 0 0 0 284.44"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-1",
    d: "M139.36,127.36c7.39,26.06-32.3,41.94-60.13,52.54-4.51-1-26.45-6.71-31-22.82-7.4-26.07,32.3-41.94,60.13-52.55,4.52,1,26.45,6.72,31,22.83M152.23,86c2.71-1.29,5.58-2.65,8.83-4.17,39.77-18.5,23-55.79,22.91-56S170-11,126.49,3.32c-23.87,7.85-51.2,21-81.25,39.19C16.37,60,3.84,91.76,12.54,125.5c7.38,28.62,31.39,50.71,60.78,56.65L70,183.44c-17,6.61-24.79,10.3-34.64,15-2.71,1.29-5.58,2.65-8.84,4.17-39.77,18.51-23,55.8-22.91,56S13.39,284.44,42,284.44a61.05,61.05,0,0,0,19.09-3.33c23.87-7.84,51.2-21,81.25-39.18,28.88-17.45,41.4-49.25,32.7-83-7.38-28.61-31.39-50.71-60.78-56.65l3.33-1.28c17-6.61,24.8-10.31,34.65-15"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "cls-1",
    d: "M259.87,122.39c0-6.85,6-11.72,14.17-11.72,8.85,0,14.61,5.31,15.93,13.71h22.81c-2-20.78-17.27-32.72-38.74-32.72-23.69,0-36.75,15-36.75,30.73,0,39.13,54.67,27.63,54.67,47.53,0,5.75-5.09,10.83-15.49,10.83-9.3,0-17.49-5.31-18.6-15h-22.8c1.33,20.55,18.16,34,41.4,34,21.25,0,38.3-11.94,38.3-29.84,0-39.35-54.9-27.86-54.9-47.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cls-1",
    d: "M397.56,152.68c0,16.13-7.3,26.08-22.36,25.86-15.05,0-22.35-9.73-22.35-26.09V93.87H329.6v60.35c0,26.53,17,45.54,45.6,45.54,27.68.22,45.61-19.23,45.61-45.32V93.87H397.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "cls-1",
    points: "437.64 197.55 460.88 197.55 460.88 93.87 437.64 93.87 437.64 197.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "cls-1",
    d: "M449.37,45.9A14.7,14.7,0,1,0,464.2,60.71,14.73,14.73,0,0,0,449.37,45.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "cls-1",
    d: "M519.77,59.16H496.31V93.87h-18.6V113.1h18.82V162c0,23.87,15.72,37.14,37,37.14a56.91,56.91,0,0,0,14.61-2V177.87c-4.43.23-6.86.23-8.19.23-13.95,0-20.15-4.87-20.15-19v-46H550.1V93.87H519.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "cls-1",
    d: "M582.64,122.39c0-6.85,6-11.72,14.17-11.72,8.86,0,14.61,5.31,15.94,13.71h22.8c-2-20.78-17.27-32.72-38.74-32.72-23.69,0-36.75,15-36.75,30.73,0,39.13,54.68,27.63,54.68,47.53,0,5.75-5.09,10.83-15.49,10.83-9.3,0-17.49-5.31-18.6-15h-22.8c1.33,20.55,18.15,34,41.4,34,21.25,0,38.29-11.94,38.29-29.84,0-39.35-54.9-27.86-54.9-47.53"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "cls-1",
    d: "M797.16,91.66c-20.81,0-31.66,13.49-33.87,18.79h-.44c-2.44-5.3-13.29-18.79-34.1-18.79-27.23,0-43.61,18.57-43.61,45.54v60.35h23.25V139c0-16.14,7.08-26.09,21.47-26.09s21.47,10,21.47,26.31v58.58h23.25V139.19c0-16.36,7.08-26.31,21.47-26.31s21.47,10,21.47,26.09v58.58h23.25V137.2c0-27-16.16-45.54-43.61-45.54"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "cls-1",
    d: "M878.85,136.54C882,121.73,893,112,908.3,112a27.44,27.44,0,0,1,27.44,24.54ZM908.3,91.66c-31,0-52.69,22.55-52.69,54.16,0,31.84,21.91,53.94,52.91,53.94,22.13,0,41.17-12.38,47.59-33.38h-22.8c-4.43,8.62-12.4,13-25,13-15.06,0-26.35-9.28-29.45-25.2h79.7c.22-3.31.22-5.08.22-8.4,0-30.95-22.14-54.16-50.47-54.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "cls-1",
    d: "M983.56,170.36a14.7,14.7,0,1,0,14.83,14.81,14.73,14.73,0,0,0-14.83-14.81"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitsMeLogoWhiteout);
export default __webpack_public_path__ + "static/media/SuitsMe_Logo_Whiteout.a5c907c356d025e41211f45e787a312a.svg";
export { ForwardRef as ReactComponent };